(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorte-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sorte-carousel')) {
 class SorteCarousel extends HTMLElement {
  connectedCallback() {
   this.track=this.querySelector('.sorte-carousel__track');
   if(!this.track)return;
   this.cards=[...this.track.querySelectorAll('.sorte-carousel__card')];
   this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
   this.abort=new AbortController();const signal=this.abort.signal;
   this.index=0;this.frame=0;this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
   this.querySelector('[data-nav]').hidden=false;this.closest('.sorte-carousel').classList.add('is-ready');
   this.prev.addEventListener('click',()=>this.move(-1),{signal});
   this.next.addEventListener('click',()=>this.move(1),{signal});
   this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());},{passive:true,signal});
   this.track.addEventListener('keydown',event=>{
    if(event.target!==this.track)return;
    if(['ArrowRight','ArrowLeft','Home','End'].includes(event.key)){
     event.preventDefault();
     if(event.key==='Home')this.go(0);else if(event.key==='End')this.go(this.cards.length-1);else this.move(event.key==='ArrowRight'?1:-1);
    }
   },{signal});
   this.track.addEventListener('focusin',event=>{
    const card=event.target.closest('.sorte-carousel__card');if(!card)return;
    const r=card.getBoundingClientRect(),t=this.track.getBoundingClientRect();
    if(r.left<t.left||r.right>t.right)this.go(this.cards.indexOf(card));
   },{signal});
   this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);
   document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.sorte-carousel__card');if(card&&this.contains(card))this.go(this.cards.indexOf(card));},{signal});
   this.update();
  }
  go(index){
   const card=this.cards[Math.max(0,Math.min(index,this.cards.length-1))];if(!card)return;
   const left=card.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft-parseFloat(getComputedStyle(this.track).paddingLeft);
   this.track.scrollTo({left,behavior:this.reduced.matches?'auto':'smooth'});
  }
  move(direction){this.go(this.index+direction);}
  update(){
   const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth),x=this.track.scrollLeft,pad=parseFloat(getComputedStyle(this.track).paddingLeft);
   const start=this.track.getBoundingClientRect().left+pad;
   let nearest=0,distance=Infinity;
   this.cards.forEach((c,i)=>{const d=Math.abs(c.getBoundingClientRect().left-start);if(d<distance){distance=d;nearest=i;}});
   this.index=nearest;this.prev.disabled=x<=2;this.next.disabled=x>=max-2;
   this.querySelector('[data-current]').textContent=String(nearest+1).padStart(2,'0');
   this.querySelector('[data-total]').textContent=String(this.cards.length).padStart(2,'0');
   const fraction=max===0?1:Math.min(1,(x+this.track.clientWidth)/this.track.scrollWidth);
   this.querySelector('[data-progress]').style.transform='scaleX('+fraction+')';
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);}
 }
 customElements.define('sorte-carousel',SorteCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorte-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sorte-marquee')) {
    class SorteMarquee extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.sorte-marquee__toggle');
        this.group = this.querySelector('.sorte-marquee__group');
        if (!this.button || !this.group) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.userPaused = false;
        this.onScreen = true;
        this.editorPaused = false;
        this.measure = () => {
          const speed = (Number(this.dataset.speed) || 45) * (this.mobile.matches ? .65 : 1);
          this.style.setProperty('--marquee-duration', Math.max(12, this.group.getBoundingClientRect().width / speed) + 's');
        };
        this.sync = () => {
          this.toggleAttribute('data-stopped', this.userPaused || this.editorPaused || !this.onScreen || document.hidden || this.reduced.matches);
          this.toggleAttribute('data-user-paused', this.userPaused);
          this.button.hidden = this.reduced.matches;
          this.button.setAttribute('aria-label', this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        };
        this.button.addEventListener('click', () => { this.userPaused = !this.userPaused; this.sync(); }, {signal});
        this.reduced.addEventListener('change', () => { this.measure(); this.sync(); }, {signal});
        this.mobile.addEventListener('change', this.measure, {signal});
        document.addEventListener('visibilitychange', this.sync, {signal});
        this.addEventListener('shopify:block:select', () => { this.editorPaused = true; this.sync(); }, {signal});
        this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.sync(); }, {signal});
        this.resize = new ResizeObserver(this.measure);
        this.resize.observe(this.group);
        this.visibility = new IntersectionObserver(entries => { this.onScreen = entries[0].isIntersecting; this.sync(); });
        this.visibility.observe(this);
        this.measure();
        this.sync();
        this.classList.add('is-ready');
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
      }
    }
    customElements.define('sorte-marquee', SorteMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
